<script setup lang="ts">
// `solid` : l'action qui prime sur le toast, pleine sur fond sombre.
defineProps<{ solid?: boolean }>();
</script>

<template>
  <button
    type="button"
    class="h-12 shrink-0 cursor-pointer rounded-[12px] border px-5 text-[14px] leading-[1.4] font-semibold sm:h-[62px] sm:px-6"
    :class="
      solid
        ? 'bg-pan-encre text-pan border-pan-encre'
        : 'border-pan-encre text-pan-encre'
    "
  >
    <slot />
  </button>
</template>
